function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "organizations",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.9,2.1 L11.9,8.1 L6.7,8.1 C6.2,8.1 5.8,8.5 5.8,9 L5.8,20.1 L12,20.1 L14.3,20.1 L22,20.1 L22,15 C22.1,14.9 22.6,14.4 23.4,14.4 C24.2,14.4 24.7,14.9 24.8,15 L24.8,20.1 L26.5,20.1 L26.5,2.1 C26.5,1.6 26.1,1.2 25.6,1.2 L12.8,1.2 C12.3,1.2 11.9,1.6 11.9,2.1 Z M10.2,17.1 L7.4,17.1 L7.4,14.2 L10.2,14.2 L10.2,17.1 Z M10.2,13 L7.4,13 L7.4,10.1 L10.2,10.1 L10.2,13 Z M13.6,3.1 L16.4,3.1 L16.4,6 L13.6,6 L13.6,3.1 L13.6,3.1 Z M13.6,7.1 L16.4,7.1 L16.4,10 L13.6,10 L13.6,7.1 L13.6,7.1 Z M16.4,14.1 L13.6,14.1 L13.6,11.2 L16.4,11.2 L16.4,14.1 Z M20.6,10.1 L17.8,10.1 L17.8,7.1 L20.6,7.1 L20.6,10.1 Z M20.6,6 L17.8,6 L17.8,3.1 L20.6,3.1 L20.6,6 Z M24.7,10.1 L21.9,10.1 L21.9,7.1 L24.7,7.1 L24.7,10.1 Z M24.7,6 L21.9,6 L21.9,3.1 L24.7,3.1 L24.7,6 Z",
  id: "Shape",
  fill: "#010101"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.4,26.7 C11.1,26.7 7.8,25.5 5.1,23.3 C2.2,20.8 0.4,17.3 0.1,13.5 C-0.3,9.6 0.9,5.9 3.4,3 C4.4,1.8 5.5,0.8 6.8,0 L7.5,1.2 C6.4,1.9 5.4,2.8 4.5,3.8 C2.2,6.5 1.2,9.8 1.4,13.3 C1.6,16.8 3.3,20 6,22.2 C10.4,25.9 16.6,26.4 21.5,23.2 L22.2,24.4 C19.8,26 17.1,26.7 14.4,26.7 Z",
  id: "Path",
  fill: "#000000"
})));

function SvgOrganizations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Organizations") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizations);
export default __webpack_public_path__ + "static/media/organizations.5fa3563e.svg";
export { ForwardRef as ReactComponent };